import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/common.css";
import TitleChnage from "../Hook/TitleChnage";

import imageOne from "../resource/hermitage/F23.png";
import imageOtwo from "../resource/hermitage/F23 (2).png";
import imageThree from "../resource/hermitage/F24.png";

import imageFive from "../resource/hermitage/L30.png";
import imageSix from "../resource/hermitage/L31 (2).png";
import imageSeven from "../resource/hermitage/L32.png";
import imageNine from "../resource/hermitage/F22.png";

const Hermitage = () => {
  TitleChnage("Hermitage");

  const navigate = useNavigate();

  const handleClick = (event) => {
    const pathMap = {
      ongoingProjects: "/ongoingProjects",
      futurePlans: "/futurePlans",
      maintenanceHermitage: "/maintenanceHermitage",
    };

    const path = event.currentTarget.id;
    const targetPath = pathMap[path];

    if (targetPath) {
      navigate(targetPath);
    }
  };

  const [isTextVisible, setIsTextVisible] = useState(false);

  const handleToggle = () => {
    setIsTextVisible((prev) => !prev);
  };

  return (
    <div className="page hermitage-page">
      <img src={imageOne} alt="" className="left-imge" />
      <img src={imageOtwo} alt="" className="right-imge" />

      <header>
        <div className="home-icon">{/* <img src="#" alt="Home Icon"> */}</div>
        <div className="title">
          <h1 className="title1">
          Monastery <span className="break"></span> Development
          </h1>
          <img src={imageThree} width={400} />
        </div>
      </header>

      <section className="intro-text p-4 ">
        <p className="text-black">
          Distancing onself from the fast-paced, busy atmosphere to embrace
          peace and tranquility within the ming--even occasionally--can
          significantly . alleviate misery. This very necessity for a societal
          refuge where individuals can retreat and enjoy inner peace and 'Noble
          Solitude', the establishment of a forest monastery and retreat centre
          becomes imperative, providing a space where one can find solace in
          quiet contemplation and spiritual solace.
          <span className="lowertext curser-pointer" onClick={handleToggle}>
            {isTextVisible ? "" : "more"}
          </span>
        </p>

        {isTextVisible && (
          <div className="hidden-text  text-black">
            <p className="title-text text-left mt-5 text-black">
              Foundational Step with the Prominent Sangha
            </p>
            <p className="mt-4">
              The Monastery was established in 2017 by the Most Venerable
              Wimalagnana Maha Thero, who graciously accepted the invitation of
              the Melbourne Buddhist community. This initiative was subsequently
              expanded to include the creation of a Monastery and Meditation
              center, addressing a long-standing need that had been eagerly
              anticipated by the community. The foundational phase of this
              project was inaugurated in July 2017, and the remarkable progress
              made within the first six years stands as a testament to its
              successful development, with the project's completion now within
              sight.
            </p>

            <p className="title-text text-left mt-5 text-black">
              Our Present Position
            </p>
            <p className="mt-4">
              The current state of the premises includes essential facilities
              that provide a comfortable environment for both the Sangha and lay
              devotees. Key facilities include:
              
            </p>

            <ul className="unorderd-list mt-4 p-4">
              <li>
                Peaceful Sangha House: Situated atop a hill, this house
                comfortably accommodates around ten members of the Sangha.
              </li>
              <li>
                Spacious Dhamma Hall: Centrally located, this hall is designed
                to host large gatherings for Dhamma sermons and Meditation
                retreats.
              </li>
              <li>
                Well-equipped Dana Sala and Kitchen: These facilities are in
                place to prepare and offer ‘Pindapatha’ to the Sangha.
              </li>
              <li>
                Existing Three Cottages: These shared facilities provide a
                comfortable logging for residents.
              </li>
              <li>
                New Yogi Kuti Complex: With 26 Kutis, available for yogis, each
                with en-suite facilities, the complex also includes two
                specially designed Kutis to accommodate individuals with
                disabilities.
              </li>
            </ul>

            <p className="mt-5">
              These facilities collectively ensure a conducive environment for
              spiritual practice and community activities.
            </p>

            <p className="mt-4">
              The premises, with its existing buildings, can comfortably
              accommodate up to 55 lay residents. It has successfully hosted
              residential meditation retreats, day programs, and various
              ceremonies and rituals.
            </p>

            <p className="mt-4">
              The development of the Monastery and Meditation Centre relies on
              the generous contributions of our community members. We therefore
              invite individuals from all backgrounds to come together and be a
              part of this noble cause.
            </p>

            <p className="mt-4">
              The ongoing development and expansion of the center further
              underscore its commitment to serving the spiritual needs of the
              community.
              <span className="lowertext curser-pointer" onClick={handleToggle}>
                {isTextVisible ? "less" : ""}
              </span>
            </p>
          </div>
        )}
      </section>

      <section className="button-section-hermitage">
        <div className="left-col">
          <img
            src={imageSeven}
            alt=""
            width={300}
            onClick={handleClick}
            id="ongoingProjects"
          />
          <img
            src={imageFive}
            alt=""
            width={300}
            onClick={handleClick}
            id="maintenanceHermitage"
          />
        </div>

        <div className="right-col">
          <img
            src={imageSix}
            alt=""
            width={300}
            onClick={handleClick}
            id="futurePlans"
          />
        </div>
      </section>

      <div className="box">
        <img src={imageNine} alt="" className="bottom-imge" />
      </div>
    </div>
  );
};

export default Hermitage;
